import style from './Interested.module.scss'

const RCProInterested = () => {
  localStorage.removeItem('RCPro')

  return (
    <div className={style.content}>
      <h1>Merci pour votre intérêt pour notre garantie RC Pro 🙏</h1>
      <p>Nous vous avons envoyé le récapitulatif de vos besoins par email. Lorsque notre offre d’assurance Responsabilité Civile Professionnelle sera disponible, vous serez parmi les premiers informés !</p>
    </div>
  )
}

export default RCProInterested